import { useEffect, useState } from 'react';

import { getOrganizationUsers } from '../services/individualBioService';
import { UserToOrganization } from '../types';

export const useOrganizationUsers = () => {
  const [users, setUsers] = useState<UserToOrganization[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    getOrganizationUsers()
      .then(setUsers)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return { users, loading, error };
};
